export const maxLength = (max, customMessage) => value =>
  value && value.length <= max
    ? true
    : customMessage
    ? customMessage(max, value)
    : "Insira no máximo " + max + " caracteres." + ` (${value.length}/${max})`;

export const moreThan = (min, customMessage) => value =>
  value && value > min
    ? true
    : customMessage
    ? customMessage(min, value)
    : "O valor deve ser maior que " + min;

export const moreOrEqualTo = (min, customMessage) => value =>
  value && value >= min
    ? true
    : customMessage
    ? customMessage(min, value)
    : "O valor deve ser maior ou igual a " + min;

export const lessThan = (max, customMessage) => value =>
  value && value < max
    ? true
    : customMessage
    ? customMessage(max, value)
    : "O valor deve ser menor que " + max;

export const lessOrEqualTo = (max, customMessage) => value =>
  value && value <= max
    ? true
    : customMessage
    ? customMessage(max, value)
    : "O valor deve ser menor ou igual a " + max;

export const equalTo = (max, customMessage) => value =>
  value && value === max
    ? true
    : customMessage
    ? customMessage(max, value)
    : "O valor deve ser ig82al a " + max;

export const required = (message = "Campo obrigatório.") => value =>
  !!value || message;

export const match = (message, valueToMatch) => value =>
  value === valueToMatch || message;

export const validUrl = message => value => {
  try {
    const parsed = new URL(value);

    if (!["http:", "https:"].includes(parsed.protocol)) {
      return message
        ? message("protocol", value)
        : "A URL deve começar com http:// ou https://";
    }

    return true;
  } catch {
    return message
      ? message("invalid", value)
      : "Informe uma URL válida (ex: https://meusite.com)";
  }
};
